import { Tooltip, TooltipProps } from "@centricsoftware/design-system";
import React, { FC, HTMLAttributes, MouseEvent, ReactElement, ReactNode } from "react";

export interface SelectableComponentProps extends HTMLAttributes<HTMLDivElement> {
	/** The child elements to be rendered inside the component */
	children: ReactNode;
	
	/** Indicates whether the component is selected */
	isSelected: boolean;
	
	/** Callback function to handle click events */
	onClick: (e: MouseEvent<HTMLDivElement>) => void;
	
	/** Color to be used for the outline when the component is selected */
	selectedColor: string;

	/** toolbar node */
	selectedTooltip?: ReactElement;

	/** props to be passed to the tooltip */
	tooltipProps?: Omit<TooltipProps, "content">;
}

export const SelectableComponent: FC<SelectableComponentProps> = ({ 
	children,
	isSelected,
	onClick,
	selectedColor,
	selectedTooltip,
	style,
	tooltipProps,
	...rest 
}) => {
	const innerDiv = (
		<div
			onClick={onClick}
			style={{
				outline: isSelected ? `2px solid ${selectedColor}` : "none",
				outlineOffset: "-2px",
				...style,
			}}
			{...rest}
		>
			{children}
		</div>
	);
	return selectedTooltip ? (
		<Tooltip
			content={selectedTooltip}
			show
			{...tooltipProps}	
		>
			{innerDiv}
		</Tooltip>
	) : (
		innerDiv
	);
};

